import { useState } from "react";
import { RedButton } from "../Buttons/RedButton";
import { truncateWalletAddress } from "../functions/Functions";
import { Copy, Check } from "lucide-react";

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <button
      onClick={handleCopy}
      className="w-6 h-6 flex items-center justify-center rounded-[6px] hover:bg-[#f0f0f0] transition-colors cursor-pointer"
    >
      {copied ? (
        <Check size={11} className="text-[#229564]" />
      ) : (
        <Copy size={11} className="text-[#aaa]" />
      )}
    </button>
  );
};

const DisconnectModal = ({ account, bech32Address, evmAddress, walletIcon, onDisconnect }) => {
  const evm = account?.startsWith("0x") ? account : evmAddress;
  const nibi = account?.startsWith("nibi") ? account : bech32Address;
  const nibiFirst = account?.startsWith("nibi");

  return (
    <div className="flex flex-col items-center gap-3 p-5 bg-white rounded-[14px] w-[300px] border border-[rgba(0,0,0,0.06)] shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
      {/* Wallet Icon */}
      <div className="w-[56px] h-[56px] rounded-full bg-[#f8f8f8] flex items-center justify-center overflow-hidden">
        {walletIcon ? (
          <img src={walletIcon} alt="wallet" className="w-[36px] h-[36px] object-contain" />
        ) : (
          <div className="w-[36px] h-[36px] rounded-full bg-gray-300" />
        )}
      </div>

      {/* Connected Badge */}
      <div
        className="flex items-center gap-[6px] px-2.5 py-1 rounded-full border border-[#b9d2c7]"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(34,149,100,0.08) 0%, rgba(34,149,100,0.08) 100%), linear-gradient(90deg, #fff 0%, #fff 100%)",
        }}
      >
        <div className="w-[6px] h-[6px] rounded-full bg-[#229564]" />
        <span className="text-[11px] font-medium text-[#229564]">Connected</span>
      </div>

      {/* Addresses — primary wallet's address shown first */}
      <div className="w-full rounded-[10px] border border-[rgba(0,0,0,0.06)] overflow-hidden">
        {(nibiFirst ? [nibi, evm] : [evm, nibi]).map((addr, i, arr) => {
          if (!addr) return null;
          const isNibi = addr.startsWith("nibi");
          return (
            <div key={addr}>
              {i > 0 && arr[i - 1] && <div className="h-[1px] bg-[rgba(0,0,0,0.04)]" />}
              <div className="flex items-center justify-between px-3 py-2.5 bg-[#fafafa]">
                <div className="flex items-center gap-2">
                  {isNibi ? (
                    <img
                      src="https://coin-images.coingecko.com/coins/images/34980/large/favicon-256x256.png"
                      alt="Nibiru"
                      className="w-[18px] h-[18px] rounded-full"
                    />
                  ) : (
                    <div className="w-[18px] h-[18px] rounded-full bg-[#627eea] flex items-center justify-center">
                      <svg width="8" height="13" viewBox="0 0 8 13" fill="none">
                        <path d="M4 0L0 6.5L4 4.8V0Z" fill="rgba(255,255,255,0.6)"/>
                        <path d="M4 0L8 6.5L4 4.8V0Z" fill="white"/>
                        <path d="M4 9.5L0 7L4 13V9.5Z" fill="rgba(255,255,255,0.6)"/>
                        <path d="M4 9.5L8 7L4 13V9.5Z" fill="white"/>
                      </svg>
                    </div>
                  )}
                  <span className="text-[12px] font-mono text-[#555]">
                    {truncateWalletAddress(addr)}
                  </span>
                </div>
                <CopyButton text={addr} />
              </div>
            </div>
          );
        })}
      </div>

      {/* Disconnect */}
      <RedButton
        text="Disconnect"
        onClick={onDisconnect}
        className="w-full h-9 !rounded-[10px] text-[13px]"
      />
    </div>
  );
};

export default DisconnectModal;
